import React from 'react';
import { Button, Col, Container, Row, Tabs, Tab } from 'react-materialize';
import { Grid, GridColumn, GridNoRecords, GridToolbar } from '@progress/kendo-react-grid';
import { ExcelExport } from '@progress/kendo-react-excel-export';
import Modal from './modal';
import axios from 'axios';
import LoadingView from '../loading/loading.view';

class ModalForaneosRep extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      orders: [],
      filteredOrders: [],
      filteredReturned: [],
      returnedArchive: [],

      loading: false,
      filterFrom: this.ymdLocal(new Date()),
      filterTo: this.ymdLocal(new Date()),
      statusTotals: {},
      expandedKey: null,
    };

    this.detailsTopCarrierRef = React.createRef();
    this.detailsTopSummaryRef = React.createRef();
  }

  SIZES = {
    headerH: 48,
    headerFont: 18,
    countFont: 16,
    pillH: 44,
    pillFont: 16,
    gap: 10,
    radius: 12,
    detailsMaxH: 360,
    detailsFont: 14,
    detailsMaxWidth: 1160,
  };

  isDept007 = () => String(this.props.user?.departmentId) === '007';

  isDelivered = (o = {}) => {
    const s = String(o.status || '').toLowerCase().trim();
    return s === 'entregado' || Boolean(o.delivered_at);
  };

  getCashierChannelCode = () => {
    const u = this.props.user || {};
    const code = String(u.salesPersonId || u.salespersonId || u.salesperson || '').toUpperCase().trim();
    const allowed = new Set(['VNAH', 'VKIS', 'VDEP', 'VIDD', 'VYIS']);
    return { myCode: allowed.has(code) ? code : null, allowed };
  };

  ymdLocal = (d = new Date()) =>
    new Intl.DateTimeFormat('en-CA', {
      timeZone: 'America/Mexico_City',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
    }).format(d);

  parseYMDLocal = (s) => {
    if (!s) return null;
    const [y, m, d] = s.split('-').map(Number);
    if (!y || !m || !d) return null;
    return new Date(y, m - 1, d, 0, 0, 0, 0);
  };

  startOfDay = (d) => new Date(d.getFullYear(), d.getMonth(), d.getDate(), 0, 0, 0, 0);
  endOfDay = (d) => new Date(d.getFullYear(), d.getMonth(), d.getDate(), 23, 59, 59, 999);

  fmtTime = (dateLike) => {
    if (!dateLike) return null;
    const d = dateLike instanceof Date ? dateLike : new Date(dateLike);
    const hh = d.getHours().toString().padStart(2, '0');
    const mm = d.getMinutes().toString().padStart(2, '0');
    const ss = d.getSeconds().toString().padStart(2, '0');
    return `${hh}:${mm}:${ss}`;
  };

  pickTs = (obj, keys = []) => {
    for (const k of keys) {
      const v = obj?.[k];
      if (v) return new Date(v);
    }
    return null;
  };

  diffHHMMSS = (obj, startKeys = [], endKeys = []) => {
    const s = this.pickTs(obj, startKeys);
    const e = this.pickTs(obj, endKeys);
    if (!s || !e) return null;
    let ms = e - s;
    if (ms < 0) ms = 0;
    const h = Math.floor(ms / 3600000).toString().padStart(2, '0');
    ms %= 3600000;
    const m = Math.floor(ms / 60000).toString().padStart(2, '0');
    ms %= 60000;
    const sec = Math.floor(ms / 1000).toString().padStart(2, '0');
    return `${h}:${m}:${sec}`;
  };

  setQuickRange = (type) => {
    const today = new Date();
    const hoy = this.ymdLocal(today);

    if (type === 'hoy') {
      this.setState({ filterFrom: hoy, filterTo: hoy, expandedKey: null }, this.recomputeFiltered);
      return;
    }
    if (type === 'ayer') {
      const y = new Date(today);
      y.setDate(y.getDate() - 1);
      this.setState({ filterFrom: this.ymdLocal(y), filterTo: this.ymdLocal(y), expandedKey: null }, this.recomputeFiltered);
      return;
    }
    if (type === '7') {
      const s = new Date(today);
      s.setDate(s.getDate() - 6);
      this.setState({ filterFrom: this.ymdLocal(s), filterTo: hoy, expandedKey: null }, this.recomputeFiltered);
      return;
    }
    if (type === 'mes') {
      const first = new Date(today.getFullYear(), today.getMonth(), 1);
      const last = new Date(today.getFullYear(), today.getMonth() + 1, 0);
      this.setState({ filterFrom: this.ymdLocal(first), filterTo: this.ymdLocal(last), expandedKey: null }, this.recomputeFiltered);
      return;
    }
    if (type === 'clear') {
      this.setState({ filterFrom: hoy, filterTo: hoy, expandedKey: null }, this.recomputeFiltered);
      return;
    }
  };

  applyRoleFilter = (list) => {
    const deptId = this.props.user?.departmentId;

    if (deptId === '003' || deptId === '005') {
      const me = this.normalize(this.props.user?.name || '');
      return list.filter((o) => this.normalize(o.sales_person) === me);
    }
    if (deptId === '004') {
      const { myCode, allowed } = this.getCashierChannelCode();
      if (!myCode) return [];

      const getAssignedCode = (o) => {
        const raw =
          o.assigned_to_spid ||
          o.assigned_to_salesperson ||
          o.assigned_to_id ||
          o.assigned_to ||
          o.assigned_to_name ||
          o.channel_code ||
          o.channel ||
          o.canal ||
          null;

        return String(raw || '').toUpperCase().trim();
      };

      return list.filter((o) => {
        const code = getAssignedCode(o);
        return code && allowed.has(code) && code === myCode;
      });
    }
    return list;
  };

  applyDateFilter = (list) => {
    const f = this.parseYMDLocal(this.state.filterFrom);
    const t = this.parseYMDLocal(this.state.filterTo);
    const start = f ? this.startOfDay(f).getTime() : null;
    const end = t ? this.endOfDay(t).getTime() : null;
    const today = new Date();
    const todayStart = this.startOfDay(today).getTime();
    const todayEnd = this.endOfDay(today).getTime();
    const is007 = this.isDept007();

    const getEffectiveTs = (o) => {
      const createdTs = o.created_at ? new Date(o.created_at).getTime() : 0;
      if (is007) {
        const delivered = this.isDelivered(o);
        const returned = this.isReturned(o);
        const isToday = createdTs >= todayStart && createdTs <= todayEnd;
        if (!delivered && !returned && !isToday) {
          return todayStart + 12 * 60 * 60 * 1000;
        }
      }
      return createdTs;
    };

    return list.filter((o) => {
      const ts = getEffectiveTs(o);
      if (start != null && ts < start) return false;
      if (end != null && ts > end) return false;
      return true;
    });
  };

  recomputeFiltered = () => {
    const base = this.applyRoleFilter(this.state.orders);

    const f = this.parseYMDLocal(this.state.filterFrom);
    const t = this.parseYMDLocal(this.state.filterTo);
    const start = f ? this.startOfDay(f).getTime() : null;
    const end = t ? this.endOfDay(t).getTime() : null;

    const today = new Date();
    const todayStart = this.startOfDay(today).getTime();
    const todayEnd = this.endOfDay(today).getTime();
    const todayYmd = this.ymdLocal(today);

    const isDept007 = String(this.props.user?.departmentId) === '007';
    const includeToday = (start == null || start <= todayEnd) && (end == null || end >= todayStart);

    const isDeliveredLocal = (o = {}) => {
      const s = String(o.status || '').toLowerCase().trim();
      return s === 'entregado' || Boolean(o.delivered_at);
    };

    const ranged = this.applyDateFilter(base);

    let rangedPlus = ranged;
    if (isDept007 && includeToday) {
      const extras = base.filter((o) => {
        const createdTs = o.created_at ? new Date(o.created_at).getTime() : 0;
        if (createdTs >= todayStart) return false;
        if (this.isReturned(o)) return false;
        if (isDeliveredLocal(o)) return false;
        return true;
      });
      rangedPlus = [...ranged, ...extras];
    }

    const ordered = [...rangedPlus].sort((a, b) => {
      const ta = a.created_at ? new Date(a.created_at).getTime() : 0;
      const tb = b.created_at ? new Date(b.created_at).getTime() : 0;
      if (ta !== tb) return ta - tb;
      return (a.id || 0) - (b.id || 0);
    });

    
    const perDayCounters = {};
    const withSeq = ordered.map((o) => {
      const createdKey = o.date_created_at || (o.created_at ? this.ymdLocal(new Date(o.created_at)) : '—');

      const carryPending =
        isDept007 && includeToday && !isDeliveredLocal(o) && !this.isReturned(o) && createdKey !== todayYmd;

      const dateKey = carryPending ? todayYmd : createdKey;

      perDayCounters[dateKey] = (perDayCounters[dateKey] || 0) + 1;

      return {
        ...o,
        turno_date: dateKey,
        turno_seq: perDayCounters[dateKey],
        carry_pending: carryPending,
        status_view: carryPending ? `${o.status || ''} (pendiente)` : o.status,
      };
    });

    const returnedBase = this.applyRoleFilter(this.state.returnedArchive);
    const filteredReturned = returnedBase
      .filter((o) => {
        const ts = o.returned_at ? new Date(o.returned_at).getTime() : 0;
        if (start != null && ts < start) return false;
        if (end != null && ts > end) return false;
        return true;
      })
      .sort((a, b) => new Date(b.returned_at || 0) - new Date(a.returned_at || 0));

    const keyOf = (o) => String(o.erp_order_id || '').trim().toUpperCase() || `id:${o.id}`;

    const timeValue = (o) => {
      const vals = [o.last_status_change_at, o.returned_at, o.changed_erp_at, o.created_at].map((v) =>
        v ? new Date(v).getTime() : 0
      );
      return Math.max(...vals);
    };

    const dedup = Object.values(
      withSeq.reduce((acc, o) => {
        const k = keyOf(o);
        const prev = acc[k];
        if (!prev || timeValue(o) > timeValue(prev)) acc[k] = o;
        return acc;
      }, {})
    );

    const filteredOrders = dedup.sort((a, b) => {
      const ta = a.created_at ? new Date(a.created_at).getTime() : 0;
      const tb = b.created_at ? new Date(b.created_at).getTime() : 0;
      if (ta !== tb) return ta - tb;
      return (a.id || 0) - (b.id || 0);
    });

    this.setState({ filteredOrders, filteredReturned });
  };

  export = () => {
    if (this._export) this._export.save();
  };
  exportReturned = () => {
    if (this._exportReturned) this._exportReturned.save();
  };

  normalize = (str) => str?.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim();

  handleCloseModal = () => {
    if (typeof this.props.onClose === 'function') this.props.onClose();
  };

  handleGridChange = (e) => {
    const updatedData = this.state.filteredOrders.map((item) =>
      item.id === e.dataItem.id ? { ...item, [e.field]: e.value } : item
    );
    this.setState({ filteredOrders: updatedData });
  };

  componentDidMount() {
    this.fetchOrders();
  }

  async fetchOrders() {
    this.setState({ loading: true });
    try {
      const { data } = await axios.get('/api/foraneos?include_returned=1');

      const statusTotals = {};
      const processed = data.map((order) => {
        const formatted = { ...order };

        const statusLower = String(order.status || '').toLowerCase().trim();
        const enviadoAt = order.shipped_at || order.enviado_at || null;

        let empacadoAt = order.empacado_at || order.packed_at || null;
        const isShippedStage = ['enviando', 'enviado', 'entregado'].includes(statusLower);
        if (!empacadoAt && isShippedStage && enviadoAt) empacadoAt = enviadoAt;

        const surtiendoAt = order.surtiendo_at || order.surtidor_asignado_at || null;
        const surtidoAt = order.surtido_at || null;
        const facturadoAt = order.facturado_at || null;
        const entregadoAt = order.delivered_at || null;

        const despachadorId =
          order.despachador_id ??
          order.dispatcher_id ??
          order.despachadorId ??
          null;

        const despachadorName =
          order.despachador_name ??
          order.despachador_nam ?? 
          order.dispatcher_name ??
          order.despachadorName ??
          null;

        const despachadorAsignadoAt =
          order.despachador_asignado_at ??
          order.dispatcher_assigned_at ??
          order.despachadorAsignadoAt ??
          null;

        Object.assign(formatted, {
          enviado_at: enviadoAt,
          empacado_at: empacadoAt,
          surtiendo_at: surtiendoAt,
          surtido_at: surtidoAt,
          facturado_at: facturadoAt,
          delivered_at: entregadoAt,

          despachador_id: despachadorId,
          despachador_name: despachadorName,
          despachador_asignado_at: despachadorAsignadoAt,

          return_reason:
            order.return_reason ||
            order.devolution_reason ||
            order.return_motive ||
            order.return_note ||
            (order.return && (order.return.reason || order.return.motive)) ||
            order.motivo_devolucion ||
            null,

          returned_at:
            order.returned_at ||
            order.devolution_at ||
            order.return_on ||
            order.devuelto_at ||
            (order.return && (order.return.date || order.return.returned_at)) ||
            null,

          returned_by:
            order.returned_by ||
            (order.return && (order.return.by || order.return.user_id)) ||
            order.devuelto_por ||
            null,

          returned_by_name:
            order.returned_by_name ||
            (order.return && (order.return.by_name || order.return.user_name)) ||
            order.devuelto_por_nombre ||
            null,

          is_returned: order.is_returned ?? order.returned ?? order.devuelto ?? null,
        });

        [
          'created_at',
          'facturado_at',
          'surtidor_asignado_at',
          'surtiendo_at',
          'surtido_at',
          'packed_at',
          'empacado_at',
          'shipped_at',
          'enviado_at',
          'delivered_at',
          'despachador_asignado_at',
        ].forEach((field) => {
          formatted[`time_${field}`] = formatted[field] ? this.fmtTime(formatted[field]) : null;
        });

        if (order.created_at) {
          const d = new Date(order.created_at);
          formatted.date_created_at = `${d.getFullYear()}-${(d.getMonth() + 1).toString().padStart(2, '0')}-${d
            .getDate()
            .toString()
            .padStart(2, '0')}`;
        } else {
          formatted.date_created_at = null;
        }

        formatted.diff_a_facturar = this.diffHHMMSS(formatted, ['created_at'], ['facturado_at']);
        formatted.diff_a_asignar_surtidor = this.diffHHMMSS(formatted, ['facturado_at'], ['surtiendo_at', 'surtidor_asignado_at']);
        formatted.diff_a_surtir = this.diffHHMMSS(formatted, ['surtidor_asignado_at'], ['surtido_at']);
        formatted.diff_a_empacar = this.diffHHMMSS(formatted, ['surtido_at'], ['empacado_at', 'packed_at']);
        formatted.diff_a_entregar = this.diffHHMMSS(formatted, ['empacado_at', 'packed_at'], ['delivered_at']);
        formatted.diff_total = this.diffHHMMSS(formatted, ['created_at'], ['delivered_at']);
        formatted.diff_factura = formatted.diff_a_facturar;
        formatted.diff_pack = this.diffHHMMSS(formatted, ['created_at'], ['empacado_at', 'packed_at']);
        formatted.diff_deliver = this.diffHHMMSS(formatted, ['empacado_at', 'packed_at'], ['delivered_at']);

        const facturaText =
          order.factura_text ??
          (order.invoice_required ? (order.invoice_id ? String(order.invoice_id) : 'Requiere') : 'No requiere');
        formatted.factura = facturaText;

        formatted.regimen = Number(order.invoice_required) === 1 ? order.tax_regimen || '—' : '—';
        formatted.uso_cfdi = Number(order.invoice_required) === 1 ? order.cfdi_use || '—' : '—';
        formatted.pending_invoice = Number(order.invoice_required) === 1 && !order.invoice_id;
        formatted.comentarios = order.advisor_comment || '';

        const erpOriginal =
          order.erp_order_id_original || order.erp_order_id_orig || order.erp_order_id_prev || null;
        formatted.erp_order_id_original = erpOriginal;

        const groupList = order.erp_group_list ?? order.group_erp_ids ?? order.group_list ?? order.groups ?? [];
        const groupCount =
          order.erp_group_count ?? order.group_count ?? (Array.isArray(groupList) ? groupList.length : 0);

        const agregadosTokens = [];
        if (erpOriginal && erpOriginal !== order.erp_order_id) {
          agregadosTokens.push(erpOriginal);
        }
        if (Array.isArray(groupList) && groupList.length) {
          agregadosTokens.push(...groupList);
        }

        formatted.agregados = agregadosTokens.length ? agregadosTokens.join(', ') : groupCount > 0 ? `+${groupCount}` : '';

        if (!statusTotals[order.status]) statusTotals[order.status] = 0;
        statusTotals[order.status]++;

        return formatted;
      });

      const keyOf = (o) => String(o.erp_order_id || '').trim().toUpperCase() || `id:${o.id}`;

      const timeValue = (o) => {
        const vals = [
          o.last_status_change_at,
          o.returned_at,
          o.changed_erp_at,
          o.facturado_at,
          o.invoice_updated_at,
          o.created_at,
        ].map((v) => (v ? new Date(v).getTime() : 0));
        return Math.max(...vals);
      };

      const dedup = Object.values(
        processed.reduce((acc, o) => {
          const k = keyOf(o);
          const prev = acc[k];
          if (!prev || timeValue(o) > timeValue(prev)) acc[k] = o;
          return acc;
        }, {})
      );

      const sorted = dedup.sort((a, b) => {
        const ta = a.created_at ? new Date(a.created_at).getTime() : 0;
        const tb = b.created_at ? new Date(b.created_at).getTime() : 0;
        if (ta !== tb) return ta - tb;
        return (a.id || 0) - (b.id || 0);
      });

      const newReturns = processed.filter(this.isReturned);
      this.setState(
        (prev) => {
          const byId = new Map(prev.returnedArchive.map((x) => [x.id, x]));
          newReturns.forEach((o) => {
            const prevO = byId.get(o.id);
            const tNew = o.returned_at ? new Date(o.returned_at).getTime() : 0;
            const tOld = prevO?.returned_at ? new Date(prevO.returned_at).getTime() : 0;
            if (!prevO || tNew >= tOld) byId.set(o.id, o);
          });
          const returnedArchive = Array.from(byId.values());
          return {
            orders: sorted,
            statusTotals,
            loading: false,
            expandedKey: null,
            returnedArchive,
          };
        },
        this.recomputeFiltered
      );
    } catch (err) {
      console.error(err);
      this.setState({ loading: false });
    }
  }

  statusToBucket = (statusRaw = '') => {
    const s = String(statusRaw).toLowerCase().trim();
    if (s === 'aplicando pago') return 'surtiendo';
    if (s === 'surtidor_asignado' || s === 'surtiendo' || s === 'facturado') return 'surtiendo';
    if (s === 'surtido') return 'surtido';
    if (s === 'empacando' || s === 'packed') return 'empacando';
    if (s === 'enviando' || s === 'enviado') return 'enviando';
    if (s === 'entregado') return 'entregados';
    return 'otros';
  };

  bucketLabel = (b) =>
    ({ surtiendo: 'Surtiendo', surtido: 'Surtido', empacando: 'Empacando', enviando: 'Enviando', entregados: 'Entregados' }[
      b
    ] || b);

  bucketColor = (b) =>
    ({ surtiendo: '#0ea5e9', surtido: '#34d399', empacando: '#6d28d9', enviando: '#f59e0b', entregados: '#10b981' }[
      b
    ] || '#9ca3af');

  getResponsible = (o, bucket) => {
    switch (bucket) {
      case 'surtiendo':
      case 'surtido':
        return o.surtidor_name || '—';
      case 'empacando':
        return o.packed_by_name || '—';
      case 'enviando':
        return o.shipped_by_name || o.delivered_by_name || '—';
      case 'entregados':
        return o.delivered_by_name || o.shipped_by_name || '—';
      default:
        return o.assigned_to_name || '—';
    }
  };

  toggleDetails = (carrier, bucket) => {
    const key = `${carrier}__${bucket}`;
    this.setState(
      (prev) => ({ expandedKey: prev.expandedKey === key ? null : key }),
      () => {
        if (this.state.expandedKey?.startsWith(`${carrier}__`) && this.detailsTopCarrierRef?.current) {
          this.detailsTopCarrierRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }
    );
  };

  toggleSummaryDetails = (bucket) => {
    const key = `ALL__${bucket}`;
    this.setState(
      (prev) => ({ expandedKey: prev.expandedKey === key ? null : key }),
      () => {
        if (this.state.expandedKey?.startsWith('ALL__') && this.detailsTopSummaryRef?.current) {
          this.detailsTopSummaryRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }
    );
  };

  isReturned = (o = {}) => {
    const status = String(o.status || '').toLowerCase().trim();
    const flags = [o.is_returned, o.returned, o.devuelto].some(Boolean);
    const hasData = Boolean(o.return_reason) || Boolean(o.returned_at);
    const isStatusDevuelto =
      status === 'devuelto' ||
      status === 'returned' ||
      status === 'returned_order' ||
      status === 'return';
    return hasData || flags || isStatusDevuelto;
  };

  getReturnedList = () => this.state.filteredReturned || [];

  fmtDateTimeLocalDisplay = (dateLike) => {
    if (!dateLike) return '—';
    const d = dateLike instanceof Date ? dateLike : new Date(dateLike);
    if (isNaN(d)) return '—';
    return d.toLocaleString('es-MX', {
      timeZone: 'America/Mexico_City',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
    });
  };

  render() {
    const S = this.SIZES;

    const byCarrier = {};
    const bucketTotals = { surtiendo: 0, surtido: 0, enviando: 0, empacando: 0, entregados: 0 };

    this.state.filteredOrders.forEach((o) => {
      const carrier = o.carrier || 'Sin paquetería';
      if (!byCarrier[carrier]) byCarrier[carrier] = [];
      byCarrier[carrier].push(o);
      const b = this.statusToBucket(o.status);
      if (bucketTotals[b] != null) bucketTotals[b] += 1;
    });

    const carrierNames = Object.keys(byCarrier).sort((a, b) => a.localeCompare(b));
    const grid5 = { display: 'grid', gridTemplateColumns: 'repeat(5, 1fr)', gap: S.gap };
    const card = {
      borderRadius: S.radius,
      border: '1px solid #e6e6e6',
      boxShadow: '0 1px 6px rgba(0,0,0,0.08)',
      overflow: 'hidden',
      display: 'grid',
      gridTemplateRows: `${S.headerH}px auto`,
    };
    const headerBar = {
      background: '#0b1020',
      color: '#fff',
      height: S.headerH,
      position: 'relative',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      letterSpacing: 0.2,
    };
    const headerName = {
      fontWeight: 900,
      fontSize: `${S.headerFont}px`,
      maxWidth: '78%',
      textAlign: 'center',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    };
    const headerCount = {
      position: 'absolute',
      right: 10,
      top: '50%',
      transform: 'translateY(-50%)',
      background: 'rgba(255,255,255,0.16)',
      color: '#fff',
      borderRadius: 9999,
      padding: '4px 10px',
      fontSize: `${S.countFont}px`,
      fontWeight: 800,
    };

    const statusesGrid = {
      padding: S.gap,
      display: 'grid',
      gridTemplateColumns: '1fr 1fr',
      gridAutoRows: `${S.pillH}px`,
      gap: S.gap,
    };

    const pillBase = {
      color: '#fff',
      borderRadius: 10,
      height: S.pillH,
      fontSize: `${S.pillFont}px`,
      fontWeight: 900,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      padding: '0 12px',
      letterSpacing: 0.2,
      userSelect: 'none',
    };
    const pillClickable = (bg, active, disabled) => ({
      ...pillBase,
      background: bg,
      cursor: disabled ? 'default' : 'pointer',
      opacity: disabled ? 0.55 : 1,
      outline: active ? '2px solid rgba(0,0,0,0.15)' : 'none',
      boxShadow: active ? '0 0 0 2px rgba(255,255,255,0.85) inset' : 'none',
      transition: 'transform .05s ease',
      display: 'flex',
      justifyContent: 'space-between',
      padding: '0 14px',
      gap: 10,
    });

    const detailsSection = {
      marginTop: 12,
      marginBottom: 12,
      maxWidth: S.detailsMaxWidth,
      marginLeft: 'auto',
      marginRight: 'auto',
    };
    const detailsHeader = (bg) => ({
      background: bg,
      color: '#fff',
      borderRadius: 12,
      minHeight: S.pillH,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: '6px 12px',
      fontWeight: 900,
      fontSize: `${S.pillFont}px`,
    });
    const chipCarrier = { background: 'rgba(0,0,0,0.15)', borderRadius: 9999, padding: '3px 10px', marginLeft: 10 };
    const closeBtn = { background: 'rgba(0,0,0,0.18)', borderRadius: 8, padding: '4px 10px', cursor: 'pointer', fontWeight: 800 };

    const tableShell = { background: '#fff', border: '1px solid #e5e7eb', borderRadius: 12, overflow: 'hidden', marginTop: 6 };
    const columnsPct = '22% 12% 12% 16% 14% 14% 10% 10%';
    const tableHeader = {
      display: 'grid',
      gridTemplateColumns: columnsPct,
      gap: 6,
      padding: '8px 10px',
      position: 'sticky',
      top: 0,
      background: '#f3f4f6',
      borderBottom: '1px solid #e5e7eb',
      fontWeight: 800,
      fontSize: `${S.detailsFont}px`,
      zIndex: 1,
    };
    const tableBody = { maxHeight: S.detailsMaxH, overflowY: 'auto' };
    const row = {
      display: 'grid',
      gridTemplateColumns: columnsPct,
      gap: 6,
      padding: '8px 10px',
      fontSize: `${S.detailsFont}px`,
      alignItems: 'center',
      borderBottom: '1px dashed #eef2f7',
    };

    let openScope = null,
      openCarrier = null,
      openBucket = null,
      openList = [];
    if (this.state.expandedKey) {
      const [c, b] = this.state.expandedKey.split('__');
      openBucket = b;
      if (c === 'ALL') {
        openScope = 'all';
        openList = this.state.filteredOrders
          .filter((o) => this.statusToBucket(o.status) === b)
          .sort((a, b) => {
            const ca = (a.carrier || 'zzz').localeCompare(b.carrier || 'zzz');
            if (ca !== 0) return ca;
            return a.id - b.id;
          });
      } else {
        openScope = 'carrier';
        openCarrier = c;
        openList = (byCarrier[c] || [])
          .filter((o) => this.statusToBucket(o.status) === b)
          .sort((a, b) => a.id - b.id);
      }
    }

    const fileName = `ReporteForaneos_${this.state.filterFrom || this.ymdLocal()}_a_${this.state.filterTo || this.ymdLocal()}.xlsx`;

    return (
      <Modal isOpen={this.props.isOpen} onClose={this.handleCloseModal}>
        <Container className="remove-padding">
          <Row>
            <Col s={12}>
              <h5 style={{ margin: '4px 0 6px' }}>Reporte de pedidos foráneos</h5>
              <Button small onClick={() => this.fetchOrders()}>
                Actualizar
              </Button>

              <div style={{ marginTop: 8, marginBottom: 8, display: 'flex', flexWrap: 'wrap', gap: 16, alignItems: 'flex-end' }}>
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                  <label style={{ fontSize: 12, color: '#666' }}>Desde</label>
                  <input
                    type="date"
                    value={this.state.filterFrom}
                    onChange={(e) => this.setState({ filterFrom: e.target.value, expandedKey: null }, this.recomputeFiltered)}
                    style={{ padding: '6px 10px', border: '1px solid #ccc', borderRadius: 6 }}
                  />
                </div>

                <div style={{ display: 'flex', flexDirection: 'column' }}>
                  <label style={{ fontSize: 12, color: '#666' }}>Hasta</label>
                  <input
                    type="date"
                    value={this.state.filterTo}
                    onChange={(e) => this.setState({ filterTo: e.target.value, expandedKey: null }, this.recomputeFiltered)}
                    style={{ padding: '6px 10px', border: '1px solid #ccc', borderRadius: 6 }}
                  />
                </div>

                <div style={{ flex: 1, display: 'flex', justifyContent: 'center', gap: 8, flexWrap: 'wrap' }}>
                  <Button small onClick={() => this.setQuickRange('hoy')} style={{ minWidth: 'unset' }}>
                    Hoy
                  </Button>
                  <Button small onClick={() => this.setQuickRange('ayer')} style={{ minWidth: 'unset' }}>
                    Ayer
                  </Button>
                  <Button small onClick={() => this.setQuickRange('7')} style={{ minWidth: 'unset' }}>
                    Últ. 7 días
                  </Button>
                  <Button small onClick={() => this.setQuickRange('mes')} style={{ minWidth: 'unset' }}>
                    Este mes
                  </Button>
                  <Button small className="grey" onClick={() => this.setQuickRange('clear')} style={{ minWidth: 'unset' }}>
                    Limpiar
                  </Button>
                </div>

                <div style={{ marginLeft: 'auto', color: '#555', fontSize: 'clamp(13px, 1.05vw, 16px)', fontWeight: 800 }}>
                  Mostrando: <b>{this.state.filteredOrders.length}</b> {this.state.filteredOrders.length === 1 ? 'turno' : 'turnos'}
                </div>
              </div>

              <Tabs>
                <Tab title="REPORTE GENERAL">
                  <div style={{ marginTop: 6 }}>
                    <h6 style={{ fontWeight: 'bold', margin: '0 0 8px', fontSize: 22 }}>Paqueterías</h6>

                    <div ref={this.detailsTopCarrierRef} />
                    {openBucket && openScope === 'carrier' && (
                      <div style={detailsSection}>
                        <div style={detailsHeader(this.bucketColor(openBucket))}>
                          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                            <span>
                              {this.bucketLabel(openBucket)} • {openList.length}
                            </span>
                            <span style={chipCarrier}>{openCarrier || '—'}</span>
                          </div>
                          <span style={closeBtn} onClick={() => this.setState({ expandedKey: null })}>
                            Cerrar ✕
                          </span>
                        </div>

                        <div style={tableShell}>
                          <div style={tableHeader}>
                            <div>Cliente</div>
                            <div>Pedido</div>
                            <div>Factura</div>
                            <div>Responsable</div>
                            <div>Vendedor</div>
                            <div>Agregados / Consolidados</div>
                            <div>Régimen</div>
                            <div>Uso CFDI</div>
                          </div>
                          <div style={tableBody}>
                            {openList.length === 0 ? (
                              <div style={{ padding: 10, color: '#6b7280' }}>Sin registros.</div>
                            ) : (
                              openList.map((o) => {
                                const hasFile = !!o.invoice_file_url;
                                const facturaNode = hasFile ? (
                                  <a href={`/${o.invoice_file_url}`} target="_blank" rel="noreferrer">
                                    {o.factura || '—'}
                                  </a>
                                ) : (
                                  o.factura || '—'
                                );

                                return (
                                  <div key={o.id} style={row}>
                                    <div style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                      {o.customer_name || '—'}
                                    </div>
                                    <div style={{ fontVariantNumeric: 'tabular-nums' }}>{o.erp_order_id || '—'}</div>
                                    <div style={{ fontVariantNumeric: 'tabular-nums', fontWeight: o.pending_invoice ? 700 : 400 }}>
                                      {facturaNode}
                                    </div>
                                    <div>{this.getResponsible(o, openBucket)}</div>
                                    <div>{o.sales_person || '—'}</div>
                                    <div style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                      {o.agregados || '—'}
                                    </div>
                                    <div title={o.regimen || ''}>{o.regimen || '—'}</div>
                                    <div title={o.uso_cfdi || ''}>{o.uso_cfdi || '—'}</div>
                                  </div>
                                );
                              })
                            )}
                          </div>
                        </div>
                      </div>
                    )}

                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(5, 1fr)', gap: S.gap }}>
                      {carrierNames.length === 0 && !this.state.loading && <p style={{ color: '#777', margin: 0 }}>No hay turnos para mostrar.</p>}
                      {this.state.loading && <LoadingView />}

                      {carrierNames.map((carrier) => {
                        const counts = { total: byCarrier[carrier].length, surtiendo: 0, surtido: 0, empacando: 0, enviando: 0, entregados: 0 };
                        byCarrier[carrier].forEach((o) => {
                          const b = this.statusToBucket(o.status);
                          if (counts[b] != null) counts[b] += 1;
                        });
                        const isOpen = (bucket) => this.state.expandedKey === `${carrier}__${bucket}`;

                        return (
                          <div key={carrier} style={card}>
                            <div style={headerBar}>
                              <div style={headerName} title={carrier}>
                                {carrier}
                              </div>
                              <div style={headerCount} title={`Total: ${counts.total}`}>
                                {counts.total}
                              </div>
                            </div>

                            <div style={statusesGrid}>
                              <div
                                style={pillClickable('#0ea5e9', isOpen('surtiendo'), counts.surtiendo === 0)}
                                onClick={() => counts.surtiendo > 0 && this.toggleDetails(carrier, 'surtiendo')}
                                title="Ver detalles"
                              >
                                <span>Surtiendo</span>
                                <span>{counts.surtiendo}</span>
                              </div>
                              <div
                                style={pillClickable('#6d28d9', isOpen('empacando'), counts.empacando === 0)}
                                onClick={() => counts.empacando > 0 && this.toggleDetails(carrier, 'empacando')}
                                title="Ver detalles"
                              >
                                <span>Empacando</span>
                                <span>{counts.empacando}</span>
                              </div>
                              <div
                                style={pillClickable('#34d399', isOpen('surtido'), counts.surtido === 0)}
                                onClick={() => counts.surtido > 0 && this.toggleDetails(carrier, 'surtido')}
                                title="Ver detalles"
                              >
                                <span>Surtido</span>
                                <span>{counts.surtido}</span>
                              </div>
                              <div
                                style={pillClickable('#f59e0b', isOpen('enviando'), counts.enviando === 0)}
                                onClick={() => counts.enviando > 0 && this.toggleDetails(carrier, 'enviando')}
                                title="Ver detalles"
                              >
                                <span>Enviando</span>
                                <span>{counts.enviando}</span>
                              </div>
                              <div style={{ gridColumn: '1 / span 2' }}>
                                <div
                                  style={pillClickable('#10b981', isOpen('entregados'), counts.entregados === 0)}
                                  onClick={() => counts.entregados > 0 && this.toggleDetails(carrier, 'entregados')}
                                  title="Ver detalles"
                                >
                                  <span>Entregados</span>
                                  <span>{counts.entregados}</span>
                                </div>
                              </div>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>

                  <div style={{ marginTop: 12 }}>
                    <h6 style={{ fontWeight: 'bold', margin: '0 0 8px', fontSize: 22 }}>Resumen general</h6>
                    <div ref={this.detailsTopSummaryRef} />
                    <div style={grid5}>
                      {[
                        { key: 'surtiendo', label: 'Surtiendo', bg: '#0ea5e9' },
                        { key: 'surtido', label: 'Surtido', bg: '#34d399' },
                        { key: 'empacando', label: 'Empacando', bg: '#6d28d9' },
                        { key: 'enviando', label: 'Enviando', bg: '#f59e0b' },
                        { key: 'entregados', label: 'Entregados', bg: '#10b981' },
                      ].map(({ key, label, bg }) => {
                        const count = bucketTotals[key] || 0;
                        const isOpen = this.state.expandedKey === `ALL__${key}`;
                        return (
                          <div
                            key={key}
                            style={pillClickable(bg, isOpen, count === 0)}
                            onClick={() => count > 0 && this.toggleSummaryDetails(key)}
                            title={count > 0 ? 'Ver detalles' : 'Sin datos'}
                          >
                            <span>{label}</span>
                            <span style={{ fontVariantNumeric: 'tabular-nums' }}>{count}</span>
                          </div>
                        );
                      })}
                    </div>

                    {openBucket && openScope === 'all' && (
                      <div style={detailsSection}>
                        <div style={detailsHeader(this.bucketColor(openBucket))}>
                          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                            <span>
                              {this.bucketLabel(openBucket)} • {openList.length}
                            </span>
                            <span style={chipCarrier}>Resumen General</span>
                          </div>
                          <span style={closeBtn} onClick={() => this.setState({ expandedKey: null })}>
                            Cerrar ✕
                          </span>
                        </div>

                        <div style={tableShell}>
                          <div style={tableHeader}>
                            <div>Cliente</div>
                            <div>Pedido</div>
                            <div>Factura</div>
                            <div>Responsable</div>
                            <div>Vendedor</div>
                            <div>Agregados / Consolidados</div>
                            <div>Régimen</div>
                            <div>Uso CFDI</div>
                          </div>
                          <div style={tableBody}>
                            {openList.length === 0 ? (
                              <div style={{ padding: 10, color: '#6b7280' }}>Sin registros.</div>
                            ) : (
                              openList.map((o) => {
                                const hasFile = !!o.invoice_file_url;
                                const facturaNode = hasFile ? (
                                  <a href={`/${o.invoice_file_url}`} target="_blank" rel="noreferrer">
                                    {o.factura || '—'}
                                  </a>
                                ) : (
                                  o.factura || '—'
                                );

                                return (
                                  <div key={o.id} style={row}>
                                    <div style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                      {o.customer_name || '—'}
                                    </div>
                                    <div style={{ fontVariantNumeric: 'tabular-nums' }}>{o.erp_order_id || '—'}</div>
                                    <div style={{ fontVariantNumeric: 'tabular-nums', fontWeight: o.pending_invoice ? 700 : 400 }}>
                                      {facturaNode}
                                    </div>
                                    <div>{this.getResponsible(o, openBucket)}</div>
                                    <div>{o.sales_person || '—'}</div>
                                    <div style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                      {o.agregados || '—'}
                                    </div>
                                    <div title={o.regimen || ''}>{o.regimen || '—'}</div>
                                    <div title={o.uso_cfdi || ''}>{o.uso_cfdi || '—'}</div>
                                  </div>
                                );
                              })
                            )}
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </Tab>

                <Tab title="REPORTE DETALLE">
                  {!this.state.loading && this.state.filteredOrders.length > 0 ? (
                    <ExcelExport ref={(exporter) => (this._export = exporter)} fileName={fileName} data={this.state.filteredOrders}>
                      <Grid data={this.state.filteredOrders} editable="incell" onItemChange={this.handleGridChange}>
                        <GridNoRecords>No se encontraron registros</GridNoRecords>
                        <GridToolbar>
                          <Button onClick={this.export}>Exportar a Excel</Button>
                        </GridToolbar>

                        <GridColumn field="turno_seq" title="Turno #" width="100px" />
                        <GridColumn field="erp_order_id" title="Pedido" width={140} />
                        <GridColumn field="quantity" title="Cantidad" width={110} />
                        <GridColumn field="customer_name" title="Cliente" width={220} />
                        <GridColumn
                          field="status"
                          title="Estatus Actual"
                          width={170}
                          cell={(p) => <td>{p.dataItem.status_view || p.dataItem.status}</td>}
                        />

                        <GridColumn field="factura" title="Factura" width={180} editable />
                        <GridColumn field="regimen" title="Régimen" width={260} />
                        <GridColumn field="uso_cfdi" title="Uso CFDI" width={180} />
                        <GridColumn field="agregados" title="Agregados / Consolidados" width={250} editable />

                        <GridColumn field="carrier" title="Paquetería" width={160} cell={(p) => <td>{p.dataItem.carrier || 'Sin paquetería'}</td>} />

                        <GridColumn
                          field="guia"
                          title="Guía"
                          width={260}
                          cell={(props) => {
                            const raw = props.dataItem.guia;
                            const parts = Array.isArray(raw) ? raw : String(raw || '').split(/[,\s;|]+/).filter(Boolean);
                            return <td style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>{parts.join('\n')}</td>;
                          }}
                        />

                        <GridColumn field="sales_person" title="Vendedor" width={170} />
                        <GridColumn field="assigned_to_name" title="Canal Asignado" width={170} />
                        <GridColumn field="comentarios" title="Comentarios" width={220} editable />
                        <GridColumn field="time_created_at" title="Hora de Registro" width={140} />

                        <GridColumn field="time_facturado_at" title="Facturado" width={140} />
                        <GridColumn field="surtidor_name" title="Surtidor" width={170} />
                        <GridColumn field="time_surtiendo_at" title="Surtiendo" width={140} />
                        <GridColumn field="time_surtido_at" title="Surtido" width={140} />
                        <GridColumn field="packed_by_name" title="Empacador" width={170} />
                        <GridColumn field="time_empacado_at" title="Empacando" width={140} />

                        {/* NUEVO: DESPACHADOR */}
                        <GridColumn field="despachador_name" title="Despachador" width={170} />
                        <GridColumn field="time_despachador_asignado_at" title="Hora Despachador" width={150} />

                        <GridColumn field="delivered_by_name" title="Entregó" width={170} />
                        <GridColumn field="time_delivered_at" title="Entregado" width={140} />

                        <GridColumn field="diff_a_facturar" title="Tiempo a Facturar" width={170} />
                        <GridColumn field="diff_a_surtir" title="Tiempo a Surtir" width={170} />
                        <GridColumn field="diff_a_empacar" title="Tiempo a Empacar" width={170} />
                        <GridColumn field="diff_a_entregar" title="Tiempo a Entregar" width={180} />
                        <GridColumn field="diff_total" title="Tiempo Total" width={160} />
                        <GridColumn field="date_created_at" title="Fecha de Registro" width={140} />
                      </Grid>
                    </ExcelExport>
                  ) : this.state.loading ? (
                    <LoadingView />
                  ) : (
                    <p style={{ margin: '6px 0', color: '#777' }}>No hay datos disponibles para exportar.</p>
                  )}
                </Tab>

                <Tab title={`TURNOS DEVUELTOS${this.getReturnedList().length ? ` (${this.getReturnedList().length})` : ''}`}>
                  {this.state.loading ? (
                    <LoadingView />
                  ) : this.getReturnedList().length === 0 ? (
                    <p style={{ margin: '6px 0', color: '#777' }}>No hay turnos devueltos en el rango seleccionado.</p>
                  ) : (
                    <>
                      {(() => {
                        const expData = this.getReturnedList().map((o) => {
                          const rawGuia = o.guia;
                          const guias = Array.isArray(rawGuia)
                            ? rawGuia
                            : String(rawGuia || '')
                                .split(/[,\s;|]+/)
                                .map((s) => s.trim())
                                .filter(Boolean);

                          return {
                            pedido: o.erp_order_id || '',
                            cliente: o.customer_name || '',
                            motivo: o.return_reason || 'Sin motivo',
                            comentarios: o.comentarios || o.advisor_comment || '',
                            cajera: o.assigned_to_name || '',
                            vendedor: o.sales_person || '',
                            paqueteria_guias: (o.carrier || 'Sin paquetería') + (guias.length ? ` • ${guias.join(' | ')}` : ''),
                            fecha_devolucion: this.fmtDateTimeLocalDisplay(o.returned_at),
                          };
                        });

                        const fileNameReturned = `TurnosDevueltos_${this.state.filterFrom || this.ymdLocal()}_a_${this.state.filterTo || this.ymdLocal()}.xlsx`;

                        return (
                          <>
                            <div style={{ margin: '6px 0 8px' }}>
                              <Button small onClick={() => this._exportReturned && this._exportReturned.save()}>
                                Exportar a Excel
                              </Button>
                            </div>

                            <div style={{ display: 'none' }}>
                              <ExcelExport ref={(r) => (this._exportReturned = r)} fileName={fileNameReturned} data={expData}>
                                <Grid data={expData}>
                                  <GridToolbar />
                                  <GridColumn field="pedido" title="Pedido" />
                                  <GridColumn field="cliente" title="Cliente" />
                                  <GridColumn field="motivo" title="Motivo devolución" />
                                  <GridColumn field="comentarios" title="Comentarios" />
                                  <GridColumn field="cajera" title="Cajera" />
                                  <GridColumn field="vendedor" title="Vendedor" />
                                  <GridColumn field="paqueteria_guias" title="Paquetería / Guías" />
                                  <GridColumn field="fecha_devolucion" title="Fecha devolución" />
                                </Grid>
                              </ExcelExport>
                            </div>
                          </>
                        );
                      })()}

                      <div style={{ background: '#fff', border: '1px solid #e5e7eb', borderRadius: 12, overflow: 'hidden' }}>
                        <div
                          style={{
                            display: 'grid',
                            gridTemplateColumns: '120px 260px 280px 260px 170px 160px 220px 180px',
                            gap: 6,
                            padding: '10px',
                            background: '#f3f4f6',
                            borderBottom: '1px solid #e5e7eb',
                            fontWeight: 800,
                          }}
                        >
                          <div>Pedido</div>
                          <div>Cliente</div>
                          <div>Motivo devolución</div>
                          <div>Comentarios</div>
                          <div>Cajera</div>
                          <div>Vendedor</div>
                          <div>Paquetería / Guías</div>
                          <div>Fecha devolución</div>
                        </div>

                        <div style={{ maxHeight: 460, overflowY: 'auto' }}>
                          {this.getReturnedList().map((o) => {
                            const rawGuia = o.guia;
                            const guias = Array.isArray(rawGuia)
                              ? rawGuia
                              : String(rawGuia || '')
                                  .split(/[,\s;|]+/)
                                  .map((s) => s.trim())
                                  .filter(Boolean);

                            return (
                              <div
                                key={o.id}
                                style={{
                                  display: 'grid',
                                  gridTemplateColumns: '120px 260px 280px 260px 170px 160px 220px 180px',
                                  gap: 6,
                                  padding: '10px',
                                  alignItems: 'center',
                                  borderBottom: '1px dashed #eef2f7',
                                  fontSize: 14,
                                }}
                              >
                                <div style={{ fontVariantNumeric: 'tabular-nums' }}>{o.erp_order_id || '—'}</div>

                                <div style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }} title={o.customer_name || ''}>
                                  {o.customer_name || '—'}
                                </div>

                                <div style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }} title={o.return_reason || ''}>
                                  {o.return_reason || 'Sin motivo'}
                                </div>

                                <div style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }} title={o.comentarios || o.advisor_comment || ''}>
                                  {o.comentarios || o.advisor_comment || '—'}
                                </div>

                                <div>{o.assigned_to_name || '—'}</div>
                                <div>{o.sales_person || '—'}</div>

                                <div style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
                                  {(o.carrier || 'Sin paquetería') + (guias.length ? ` • ${guias.join('\n')}` : '')}
                                </div>

                                <div style={{ fontVariantNumeric: 'tabular-nums' }}>{this.fmtDateTimeLocalDisplay(o.returned_at)}</div>
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    </>
                  )}
                </Tab>
              </Tabs>
            </Col>
          </Row>
        </Container>
      </Modal>
    );
  }
}

export default ModalForaneosRep;
